<section class="consignment-rec-container full">
  <app-recall-pack-item-header></app-recall-pack-item-header>
  <router-outlet></router-outlet>
</section>
<app-footer></app-footer>
